// extracted by mini-css-extract-plugin
export default {"heading":"AccountDeleted_heading__NAZYN","forwardButton":"AccountDeleted_forwardButton__FwLVF"};